/**
 * @ComponentFor Avensia.Shop.Features.Pantries.Pages.List.Toolbar.PrintOptions
 */
import React from "react";
import { translate } from "Shared/translate";
import DropDownMenu, { DropDownItem } from "Shared/DropDownMenu";
import * as styles from "./printOptions.scss";
import PrintActions from "./PrintActions";
import { DropDownListType } from ".";
const printOptions = {};
const defaultName = "default";
class PrintOptions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            printOption: "",
            printOptionTitle: translate("/Account/ProductList/PrintOptions/DropDown/Heading"),
        };
    }
    UNSAFE_componentWillMount() {
        printOptions["item"] = translate("/Account/ProductList/PrintOptions/DropDown/Item");
        printOptions["area"] = translate("/Account/ProductList/PrintOptions/DropDown/Area");
        printOptions["pantry"] = translate("/Account/ProductList/PrintOptions/DropDown/Pantry");
        printOptions[defaultName] = this.state.printOptionTitle;
    }
    changeSelect(option) {
        this.props.handleDropDownSelect(DropDownListType.Print);
        if (this.state.printOption == option) {
            this.changeSelect(defaultName);
            if (this.props.active)
                return;
        }
        this.setState({
            printOption: option,
            printOptionTitle: printOptions[option],
        });
    }
    hasChoice() {
        return (!!this.state.printOption &&
            this.state.printOption != defaultName &&
            this.props.active);
    }
    render() {
        return (React.createElement("div", { className: styles.printOptions },
            React.createElement("div", { className: styles.printOptionsInner },
                React.createElement("div", { className: styles.selectWrapper },
                    React.createElement("div", { className: styles.dropdownWrap },
                        React.createElement(DropDownMenu, { overrideMobile: true, title: this.props.active
                                ? this.state.printOptionTitle
                                : printOptions[defaultName], className: styles.dropdownPrint, isActive: this.hasChoice() },
                            React.createElement(DropDownItem, { key: "PrintOptionsDropDownItem", value: "item", text: translate("/Account/ProductList/PrintOptions/DropDown/Item"), onClick: (e) => this.changeSelect("item") }),
                            React.createElement(DropDownItem, { key: "PrintOptionsDropDownArea", value: "area", text: translate("/Account/ProductList/PrintOptions/DropDown/Area"), onClick: (e) => this.changeSelect("area") }),
                            React.createElement(DropDownItem, { key: "PrintOptionsDropDownPantry", value: "pantry", text: translate("/Account/ProductList/PrintOptions/DropDown/Pantry"), onClick: (e) => this.changeSelect("pantry") }))),
                    React.createElement(PrintActions, { reportType: this.state.printOption, visible: this.hasChoice() })))));
    }
}
export default PrintOptions;
